var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.38619 17C5.15592 16.9996 4.92972 16.9383 4.72985 16.8223C4.27979 16.5636 4 16.0615 4 15.5163V4.48376C4 3.93707 4.27979 3.43642 4.72985 3.17773C4.93448 3.05844 5.16694 2.99709 5.40294 3.00011C5.63894 3.00312 5.86981 3.07038 6.07141 3.19485L15.3671 8.83895C15.5608 8.96217 15.7205 9.13328 15.8312 9.33623C15.9419 9.53918 16 9.76733 16 9.99927C16 10.2312 15.9419 10.4594 15.8312 10.6623C15.7205 10.8653 15.5608 11.0364 15.3671 11.1596L6.06991 16.8052C5.8636 16.9317 5.62728 16.9991 5.38619 17Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlay);
export default __webpack_public_path__ + "static/media/icon-play.fb6fcc58171f308f878c0dd15cd39d95.svg";
export { ForwardRef as ReactComponent };